import React, { useCallback } from 'react';
import { token } from '@atlaskit/tokens';
import InfoIcon from '@atlaskit/icon/core/status-information';
import { useFlagsService } from '@atlassian/jira-flags';
import messages from './messages.tsx';

const REALTIME_UPDATE_EXCEEDED_MAX_FLAG_ID =
	'jira-issue-realtime-updates.ui.flag.info.realtime-update-exceeded-max-flag';

export const useRealtimeUpdateExceededMaxFlag = () => {
	const { showFlag, hasFlag, dismissFlag } = useFlagsService();

	return useCallback(
		({ onRefresh }: { onRefresh: () => void }) => {
			if (!hasFlag?.(REALTIME_UPDATE_EXCEEDED_MAX_FLAG_ID)) {
				showFlag({
					type: 'info',
					icon: <InfoIcon spacing="spacious" label="" color={token('color.icon.information')} />,
					title: messages.realtimeUpdateExceededMaxHeader,
					description: messages.realtimeUpdateExceededMaxDescription,
					messageId: REALTIME_UPDATE_EXCEEDED_MAX_FLAG_ID,
					id: REALTIME_UPDATE_EXCEEDED_MAX_FLAG_ID,
					messageType: 'transactional',
					isAutoDismiss: true,
					actions: [
						{
							content: messages.realtimeUpdateExceededMaxRefreshButton,
							onClick: () => {
								dismissFlag(REALTIME_UPDATE_EXCEEDED_MAX_FLAG_ID);
								onRefresh();
							},
						},
					],
				});
			}
		},
		[dismissFlag, hasFlag, showFlag],
	);
};
